module.exports = __webpack_public_path__ + "static/media/servImg3.ae2b59db.svg";